import { render, staticRenderFns } from "./unregistered-users.vue?vue&type=template&id=4c5e158c&"
import script from "./unregistered-users.ts?vue&type=script&lang=ts&"
export * from "./unregistered-users.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports